import { Slot } from "radix-ui";
import * as React from "react";
import { type VariantProps } from "tailwind-variants";

import { cn } from "@/lib/utils";

import { pushButtonVariants } from "./variants";

type ButtonVariants = VariantProps<typeof pushButtonVariants>;

interface ButtonProps extends React.ComponentProps<"button">, ButtonVariants {
  children: React.ReactNode;
  asChild?: boolean;
}

const PushButton = ({
  className,
  active,
  size,
  asChild = false,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot.Root : "button";
  return (
    <Comp
      className={cn(pushButtonVariants({ active, size, className }))}
      {...props}
    />
  );
};

export { PushButton };
